module.exports = __webpack_public_path__ + "img/logo-mobile.d3fd861e.svg";